//빅 포스터용 데이터 6개
export const mainItems = [
  {
    id: '0x9ECa514834509b4D5091b6bb1eB0afCa4881B02e',
    topic: '공연',
    posterImgUrl: 'https://ticketimage.interpark.com/Play/image/large/22/22010748_p.gif',
    detailInfoImg: 'https://ticketimage.interpark.com/Play/image/etc/22/22010748-12.jpg',
    title: 'BLACKPINK WORLD TOUR',
    place: '올림픽공원 KSPO DOME',
    cast: '블랙핑크',
    viewAgeName: '15세이상',
    cashPrice: [300, 500, 700],
    startDate: 1677164400000,
    endDate: 1677250800000,
    preTicketing: [1672585200000, 1673621999999],
    preTicketingList: ['0xA4C40d1568E1a4a94B0b4E9b787190bF529934d3'],
    runningTime: 120,
    dateInfo: {
      1677164400000: [
        {
          startTime: 1677218400000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1677229200000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
      1677250800000: [
        {
          startTime: 1677304800000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
    },
  },
  {
    id: '0x909304Ea4C5eF2696e581B24a112BFa0672b7dF4',
    topic: '공연',
    posterImgUrl: 'https://image.toast.com/aaaaab/ticketlink/TKL_8/poster(220915)b.jpg',
    detailInfoImg: 'http://image.toast.com/aaaaab/ticketlink/TKL_4/fu_web_1_220825.jpg',
    title: '2022 푸에르자부르타 웨이라 인 서울',
    place: '잠실종합운동장 FB씨어터',
    cast: '푸에르자부르타',
    viewAgeName: '8세 이상',
    cashPrice: [300, 500, 700],
    startDate: 1675954800000,
    endDate: 1676041200000,
    preTicketing: [],
    preTicketingList: [],
    runningTime: 90,
    dateInfo: {
      1675954800000: [
        {
          startTime: 1676008800000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1676019600000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
      1676041200000: [
        {
          startTime: 1676095200000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
    },
  },
  {
    id: '0xEB236b70f56Ed8293D7728d5A9d7fB808d6Dbe6F',
    topic: '전시',
    posterImgUrl: 'https:////image.toast.com/aaaaab/ticketlink/TKL_5/티켓링크_405x500.jpg',
    detailInfoImg: 'http://image.toast.com/aaaaab/ticketlink/TKL_3/221116_AW_700.jpg',
    title: 'WATSON, THE MAESTRO - 사진전',
    place: '예술의전당 한가람미술관 2층',
    cast: '알버트 왓슨',
    viewAgeName: '19세 이상',
    cashPrice: [300, 500, 700],
    startDate: 1674831600000,
    endDate: 1675004400000,
    preTicketing: [1672585200000, 1673621999999],
    preTicketingList: ['0xA4C40d1568E1a4a94B0b4E9b787190bF529934d3'],
    runningTime: 120,
    dateInfo: {
      1674831600000: [
        {
          startTime: 1674864000000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
      1674918000000: [
        {
          startTime: 1674950400000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
      1675004400000: [
        {
          startTime: 1675036800000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
    },
  },
  {
    id: '0xeE7C899b012F42B227af9E8FBa557fA8B86501D4',
    topic: '전시',
    posterImgUrl: 'https://image.toast.com/aaaaab/ticketlink/TKL_6/tech_pst0308.jpg',
    detailInfoImg: 'http://image.toast.com/aaaaab/ticketlink/TKL_6/tech_info0308-01.jpg',
    title: 'Technique of Healing - 부산',
    place: '해운대구 센텀서로 20 뮤지엄원',
    cast: 'museum',
    viewAgeName: '전체관람가',
    cashPrice: [300, 500, 700],
    startDate: 1675177200000,
    endDate: 1675350000000,
    preTicketing: [],
    preTicketingList: [],
    runningTime: 120,
    dateInfo: {
      1675177200000: [
        {
          startTime: 1675209600000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
      1675263600000: [
        {
          startTime: 1675296000000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
      1675350000000: [
        {
          startTime: 1675382400000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
    },
  },
  {
    id: '0x2933cF2Cc7737E3fb74ABCa21af2F36240661F48',
    topic: '스포츠',
    posterImgUrl: 'https://ticketimage.interpark.com/Play/image/large/22/22015838_p.gif',
    detailInfoImg: 'https://ticketimage.interpark.com/Play/image/etc/22/22015838-01.jpg',
    title: '파퀴아오 vs DK YOO',
    place: '일산 킨텍스 3F 그랜드볼룸',
    cast: '파퀴아오, DK YOO',
    viewAgeName: '15세 이상',
    cashPrice: [300, 500, 700],
    startDate: 1676386800000,
    endDate: 1676386800000,
    preTicketing: [1672585200000, 1672757999000],
    preTicketingList: ['0xA4C40d1568E1a4a94B0b4E9b787190bF529934d3'],
    runningTime: 90,
    dateInfo: {
      1676386800000: [
        {
          startTime: 1676440800000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
    },
  },
  {
    id: '0xcCb79578A000d3c2C0a908271c8B5D939Dad0414',
    topic: '스포츠',
    posterImgUrl: 'https://news.nateimg.co.kr/orgImg/na/2022/04/14/5317599_high.jpg',
    detailInfoImg: 'https://www.jejutwn.com/data/photos/20220624/art_16554512927773_d72133.jpg',
    title: '팀 K리그 vs 토트텀 홋스퍼',
    place: '서울월드컵경기장',
    cast: '토트넘',
    viewAgeName: '11세 이상',
    cashPrice: [300, 500, 700],
    startDate: 1676818800000,
    endDate: 1676818800000,
    preTicketing: [],
    preTicketingList: [],
    runningTime: 120,
    dateInfo: {
      1676818800000: [
        {
          startTime: 1676872800000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
    },
  },
];

//TODO:일반 포스터용 데이터 15개
export const restItems = [
  {
    id: '0x40A780dAC526c4F500ED4a1B1Ec2BC460B4d45F8',
    topic: '전시',
    posterImgUrl: 'https://image.toast.com/aaaaab/ticketlink/TKL_1/314x382(1).jpg',
    detailInfoImg: 'http://image.toast.com/aaaaab/ticketlink/TKL_3/t.jpg',
    title: '프리다 칼로 사진전 / FRIDA KAHLO EXHIBITION',
    place: '현대백화점 무역센터점',
    cast: '프라다 칼로',
    viewAgeName: '전체이용가',
    cashPrice: [300, 500, 700],
    startDate: 1677942000000,
    endDate: 1678374000000,
    preTicketing: [],
    preTicketingList: [],
    runningTime: 100,
    dateInfo: {
      1677942000000: [
        {
          startTime: 1677985200000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1678003200000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
      1678028400000: [
        {
          startTime: 1678071600000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1678089600000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
      1678114800000: [
        {
          startTime: 1678158000000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1678176000000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
      1678201200000: [
        {
          startTime: 1678244400000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1678262400000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
      1678287600000: [
        {
          startTime: 1678330800000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1678348800000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
      1678374000000: [
        {
          startTime: 1678417200000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1678435200000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
    },
  },
  {
    id: '0x209AB5F1544Bb971BC0B8Db89e30ee185bbD6a4D',
    topic: '전시',
    posterImgUrl: 'https://image.toast.com/aaaaab/ticketlink/TKL_1/main,405.jpg',
    detailInfoImg: 'http://image.toast.com/aaaaab/ticketlink/TKL_7/b_bri1201.jpg',
    title: '엉덩이 탐정 플레이파크 미션 대모험',
    place: '현대백화점 미아점,천호점,킨텍스점',
    cast: '코난',
    viewAgeName: '전체이용가',
    cashPrice: [300, 500, 700],
    startDate: 1675782000000,
    endDate: 1676041200000,
    preTicketing: [],
    preTicketingList: [],
    runningTime: 180,
    dateInfo: {
      1675782000000: [
        {
          startTime: 1675825200000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1675843200000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
      1675868400000: [
        {
          startTime: 1675911600000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1675929600000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
      1675954800000: [
        {
          startTime: 1675998000000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1676016000000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
      1676041200000: [
        {
          startTime: 1676084400000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1676102400000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
    },
  },
  {
    id: '0x40d144Ee395fCBaba1d0C9B8A8aE6aBe7C5B2aa6',
    topic: '전시',
    posterImgUrl: 'https://image.toast.com/aaaaab/ticketlink/TKL_10/dv_pst0816.jpg',
    detailInfoImg: 'http://image.toast.com/aaaaab/ticketlink/TKL_7/tl1.jpg',
    title: '뒤뷔페전 - 프랑스 현대미술의 거장 Dubuffet + Villeglé. Une affiche dans la ville',
    place: '올림픽공원 소마미술관 2관',
    cast: '뒤뷔페',
    viewAgeName: '2세 이상',
    cashPrice: [300, 500, 700],
    startDate: 1674486000000,
    endDate: 1674831600000,
    preTicketing: [],
    preTicketingList: [],
    runningTime: 0,
    dateInfo: {
      1674486000000: [
        {
          startTime: 1674529200000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1674547200000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
      1674572400000: [
        {
          startTime: 1674615600000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1674633600000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
      1674658800000: [
        {
          startTime: 1674702000000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1674720000000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
      1674745200000: [
        {
          startTime: 1674788400000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1674806400000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
      1674831600000: [
        {
          startTime: 1674874800000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1674892800000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
    },
  },
  {
    id: '0x4fdA327241A2d3c3b53C5B44ef8f9dFb8f0978d1',
    topic: '전시',
    posterImgUrl: 'https://image.toast.com/aaaaab/ticketlink/TKL_10/hari.jpg',
    detailInfoImg: 'http://image.toast.com/aaaaab/ticketlink/TKL_7/tl01(2).jpg',
    title: '하리보 골드베렌 100주년 생일 기념전',
    place: '안녕인사동 B1인사센트럴 뮤지엄',
    cast: '하리보',
    viewAgeName: '2세 이상',
    cashPrice: [300, 500, 700],
    startDate: 1674486000000,
    endDate: 1674658800000,
    preTicketing: [],
    preTicketingList: [],
    runningTime: 0,
    dateInfo: {
      1674486000000: [
        {
          startTime: 1674529200000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1674547200000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
      1674572400000: [
        {
          startTime: 1674615600000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1674633600000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
      1674658800000: [
        {
          startTime: 1674702000000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1674720000000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
    },
  },
  {
    id: '0x48fE5AcB002C985a3F3E44EdD945852b3B211550',
    topic: '스포츠',
    posterImgUrl: 'https://image.toast.com/aaaaab/ticketlink/TKL_8/main(1).png',
    detailInfoImg: 'http://image.toast.com/aaaaab/ticketlink/TKL_6/1(18).jpg',
    title: '[평창] 휘닉스 평창 올데이/하프데이 패스 22/23 동계시즌',
    place: '강원도 평창군 봉평면 태기로 174 휘닉스파크',
    cast: '휘닉스',
    viewAgeName: '5세 이상',
    cashPrice: [300, 500, 700],
    startDate: 1672498800000,
    endDate: 1672758000000,
    preTicketing: [],
    preTicketingList: [],
    runningTime: 0,
    dateInfo: {
      1672498800000: [
        {
          startTime: 1672542000000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1672560000000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
      1672585200000: [
        {
          startTime: 1672628400000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1672646400000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
      1672671600000: [
        {
          startTime: 1672714800000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1672732800000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
      1672758000000: [
        {
          startTime: 1672801200000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1672819200000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
    },
  },
  {
    id: '0x4589cd2Cc1eEd4E6319714De0e39c5496aB27791',
    topic: '스포츠',
    posterImgUrl: 'https://image.toast.com/aaaaab/ticketlink/TKL_7/asl_221004.jpg',
    detailInfoImg: 'http://image.toast.com/aaaaab/ticketlink/TKL_2/asl_Web_221004.jpg',
    title: 'ASL 시즌14 결승전 | 김지성(T) vs 유영진(T)',
    place: '서울특별시 마포구 매봉산로 31 에스플렉스센터',
    cast: '김지성, 유영진',
    viewAgeName: '만12세이상',
    cashPrice: [300, 500, 700],
    startDate: 1674486000000,
    endDate: 1674486000000,
    preTicketing: [],
    preTicketingList: [],
    runningTime: 0,
    dateInfo: {
      1674486000000: [
        {
          startTime: 1674529200000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1674547200000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
    },
  },
  {
    id: '0x24C4A4ea34aE86311BAc456261718fB40bcfC6a1',
    topic: '스포츠',
    posterImgUrl:
      'https://image.toast.com/aaaaab/ticketlink/TKL_6/20221101_%EB%B7%B0%EC%9E%89%ED%8C%8C%ED%8B%B0_%ED%8B%B0%EC%BC%93%EC%9D%B4%EB%AF%B8%EC%A7%80_405X500.jpg',
    detailInfoImg:
      'http://image.toast.com/aaaaab/ticketlink/TKL_5/20221101_%EB%B7%B0%EC%9E%89%ED%8C%8C%ED%8B%B0_%ED%8B%B0%EC%BC%93%EC%9D%B4%EB%AF%B8%EC%A7%80_1120.png',
    title: '더 뜨겁게 FIFA 온라인 4 뷰잉파티 [3차전]',
    place: '경기도 광명시 양지로 17 IVEX 스튜디오',
    cast: '손홍민',
    viewAgeName: '만19세 이상',
    cashPrice: [300, 500, 700],
    startDate: 1676041200000,
    endDate: 1676214000000,
    preTicketing: [],
    preTicketingList: [],
    runningTime: 0,
    dateInfo: {
      1676041200000: [
        {
          startTime: 1676084400000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1676102400000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
      1676127600000: [
        {
          startTime: 1676170800000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1676188800000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
      1676214000000: [
        {
          startTime: 1676257200000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1676275200000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
    },
  },
  {
    id: '0x70f368fA399E6A280f68DC9B1C7Afc9Ba35DcA98',
    topic: '스포츠',
    posterImgUrl: 'https://image.toast.com/aaaaab/ticketlink/TKL_3/OGN-PUBG-0922.jpg',
    detailInfoImg: 'http://image.toast.com/aaaaab/ticketlink/TKL_1/OGN-web-0922.jpg',
    title: 'PUBG KOREA LEAGUE 2018 #2',
    place: '서울특별시 마포구 매봉산로 31 에스플렉스 센터 15~16층',
    cast: '게이머',
    viewAgeName: '만15세 이상',
    cashPrice: [300, 500, 700],
    startDate: 1676559600000,
    endDate: 1676818800000,
    preTicketing: [],
    preTicketingList: [],
    runningTime: 0,
    dateInfo: {
      1676559600000: [
        {
          startTime: 1676602800000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1676620800000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
      1676646000000: [
        {
          startTime: 1676689200000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1676707200000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
      1676732400000: [
        {
          startTime: 1676775600000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1676793600000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
      1676818800000: [
        {
          startTime: 1676862000000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1676880000000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
    },
  },
  {
    id: '0xA4C40d1568E1a4a94B0b4E9b787190bF529934d3',
    topic: '공연',
    posterImgUrl: 'https://image.toast.com/aaaaab/ticketlink/TKL_6/펭미팅_대표이미지_405X500.jpg',
    detailInfoImg: 'http://image.toast.com/aaaaab/ticketlink/TKL_2/MD_1128.jpg',
    title: '2022 펭수 연말 펭미팅',
    place: '경희대학교 평화의전당',
    cast: '펭수',
    viewAgeName: '8세 이상',
    cashPrice: [300, 500, 700],
    startDate: 1672326000000,
    endDate: 1672412400000,
    preTicketing: [],
    preTicketingList: [],
    runningTime: 90,
    dateInfo: {
      1672326000000: [
        {
          startTime: 1672380000000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
      1672412400000: [
        {
          startTime: 1672466400000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
    },
  },
  {
    id: '0xa2e8166DC2341457779E82A1677362A9fd4a9b79',
    topic: '공연',
    posterImgUrl: 'https://image.toast.com/aaaaab/ticketlink/TKL_10/im_pst1111.jpg',
    detailInfoImg: 'http://image.toast.com/aaaaab/ticketlink/TKL_2/im_sw_info1111.jpg',
    title: '2022년 임재범 전국투어 콘서트 - 수원',
    place: '경기도 수원시 영통구 광교중앙로 140 수원컨벤션센터',
    cast: '임재범',
    viewAgeName: '만7세 이상',
    cashPrice: [300, 500, 700],
    startDate: 1674572400000,
    endDate: 1674658800000,
    preTicketing: [],
    preTicketingList: [],
    runningTime: 0,
    dateInfo: {
      1674572400000: [
        {
          startTime: 1674615600000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1674633600000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
      1674658800000: [
        {
          startTime: 1674702000000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1674720000000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
    },
  },
  {
    id: '0x34684e61e4C5dd15dc0aAB63F50e2dCf6E76F4Fb',
    topic: '공연',
    posterImgUrl: 'https://image.toast.com/aaaaab/ticketlink/TKL_10/z_pst1221.jpg',
    detailInfoImg: 'http://image.toast.com/aaaaab/ticketlink/TKL_3/z_noti1221.jpg',
    title: '잔나비 전국투어 <판타스틱 올드 패션드 송년회> - 천안',
    place: '상명대학교 천안캠퍼스 계당관',
    cast: '잔나비',
    viewAgeName: '7세 이상',
    cashPrice: [300, 500, 700],
    startDate: 1676559600000,
    endDate: 1676818800000,
    preTicketing: [],
    preTicketingList: [],
    runningTime: 0,
    dateInfo: {
      1676559600000: [
        {
          startTime: 1676602800000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1676620800000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
      1676646000000: [
        {
          startTime: 1676689200000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1676707200000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
      1676732400000: [
        {
          startTime: 1676775600000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1676793600000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
      1676818800000: [
        {
          startTime: 1676862000000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1676880000000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
    },
  },
  {
    id: '0x8c48ADb5Ee88Da5a8f58289411DCD21Bc478eDEC',
    topic: '공연',
    posterImgUrl: 'https://image.toast.com/aaaaab/ticketlink/TKL_7/kyj_221027.jpg',
    detailInfoImg: 'http://image.toast.com/aaaaab/ticketlink/TKL_2/web1027(1).jpg',
    title: '2023 김연자 라이브 콘서트 - 대구',
    place: '대구광역시 북구 엑스코로 10 엑스코 오디토리움',
    cast: '연자킴',
    viewAgeName: '10세 이상',
    cashPrice: [300, 500, 700],
    startDate: 1675263600000,
    endDate: 1675263600000,
    preTicketing: [],
    preTicketingList: [],
    runningTime: 0,
    dateInfo: {
      1675263600000: [
        {
          startTime: 1675306800000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1675324800000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
    },
  },
  {
    id: '0xf204a805d1e8d9aBF596b22dB2ee094420456A41',
    topic: '공연',
    posterImgUrl: 'https://image.toast.com/aaaaab/ticketlink/TKL_7/Ashnikko-Poster_1125.jpg',
    detailInfoImg: 'http://image.toast.com/aaaaab/ticketlink/TKL_3/a_info_1209.jpg',
    title: 'TOUR 2023 아시니코 내한공연',
    place: '서울특별시 마포구 잔다리로 32 왓챠홀',
    cast: '아시니코',
    viewAgeName: '18세 이상',
    cashPrice: [300, 500, 700],
    startDate: 1680015600000,
    endDate: 1680015600000,
    preTicketing: [],
    preTicketingList: [],
    runningTime: 0,
    dateInfo: {
      1680015600000: [
        {
          startTime: 1680058800000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          startTime: 1680076800000,
          seatCount: 81,
          seats: {
            sections: [
              {
                event_id: 2,
                name: 'Bronze',
                price: 300,
                subsections: [
                  {
                    id: 18,
                    section_id: 6,
                    name: 'B1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 19,
                    section_id: 6,
                    name: 'B2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 20,
                    section_id: 6,
                    name: 'B3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Bronze-B3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Bronze-B3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Bronze-B3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Bronze-B3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Silver',
                price: 500,
                subsections: [
                  {
                    id: 22,
                    section_id: 7,
                    name: 'S1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 23,
                    section_id: 7,
                    name: 'S2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 24,
                    section_id: 7,
                    name: 'S3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Silver-S3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Silver-S3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Silver-S3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Silver-S3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
              {
                event_id: 2,
                name: 'Gold',
                price: 700,
                subsections: [
                  {
                    id: 26,
                    section_id: 8,
                    name: 'G1',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G1-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G1-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G1-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G1-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 27,
                    section_id: 8,
                    name: 'G2',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G2-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G2-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G2-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G2-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                  {
                    id: 28,
                    section_id: 8,
                    name: 'G3',
                    seats_by_rows: {
                      1: [
                        {
                          name: 'Gold-G3-1-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-1-3',
                          status: 'free',
                        },
                      ],
                      2: [
                        {
                          name: 'Gold-G3-2-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-2-3',
                          status: 'free',
                        },
                      ],
                      3: [
                        {
                          name: 'Gold-G3-3-1',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-2',
                          status: 'free',
                        },
                        {
                          name: 'Gold-G3-3-3',
                          status: 'free',
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
    },
  },
];
